import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, Table, TableHead, TableBody, TableRow,
  TableCell, TableContainer, TablePagination, Select, MenuItem, FormControl,
  InputLabel, Chip, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  Alert, Skeleton } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { viewerAPI } from '../../services/api';
import dayjs from 'dayjs';

export default function ViewerApplications() {
  var cx = useState(null); var context = cx[0]; var setContext = cx[1];
  var fs = useState(''); var formId = fs[0]; var setFormId = fs[1];
  var rs = useState([]); var rows = rs[0]; var setRows = rs[1];
  var ts = useState(0); var total = ts[0]; var setTotal = ts[1];
  var ps = useState(0); var page = ps[0]; var setPage = ps[1];
  var pp = useState(25); var perPage = pp[0]; var setPerPage = pp[1];
  var ds = useState(null); var detail = ds[0]; var setDetail = ds[1];
  var ld = useState(true); var loading = ld[0]; var setLoading = ld[1];

  useEffect(function() {
    viewerAPI.context().then(function(r) {
      var c = r.data.data;
      setContext(c);
      if (c.forms && c.forms.length > 0) setFormId(c.forms[0].id);
      setLoading(false);
    }).catch(function() { setLoading(false); });
  }, []);

  useEffect(function() {
    if (!formId) return;
    viewerAPI.applications({ form_id: formId, page: page + 1, per_page: perPage })
      .then(function(r) {
        setRows(r.data.data.data || []);
        setTotal(r.data.data.total || 0);
      }).catch(function() { setRows([]); });
  }, [formId, page, perPage]);

  function open(id) {
    viewerAPI.application(id).then(function(r) { setDetail(r.data.data); });
  }

  var E = React.createElement;

  if (loading) return E(Skeleton, {variant:'rectangular', height:300, sx:{borderRadius:2}});

  var forms = (context && context.forms) || [];
  if (forms.length === 0) {
    return E(Card, null, E(CardContent, {sx:{textAlign:'center', py:8}},
      E(Typography, {variant:'h6', sx:{mb:1}}, 'No forms shared with you'),
      E(Typography, {color:'text.secondary'},
        'An administrator decides which forms you can see.')));
  }

  // Build a label lookup so the detail view shows questions, not field ids.
  var schema = null;
  if (detail) {
    schema = typeof detail.form_schema === 'string' ? JSON.parse(detail.form_schema) : detail.form_schema;
    if (typeof schema === 'string') { try { schema = JSON.parse(schema); } catch (e) { schema = {}; } }
  }
  var fields = schema ? (schema.fields || []).slice().sort(function(a,b){ return (a.order||0)-(b.order||0); }) : [];
  var sections = schema ? (schema.sections || []).slice().sort(function(a,b){ return (a.order||0)-(b.order||0); }) : [];

  return E(Box, null,
    E(Box, {sx:{display:'flex', justifyContent:'space-between', alignItems:'center',
      flexWrap:'wrap', gap:2, mb:2}},
      E(Typography, {variant:'h4'}, 'Applications'),
      forms.length > 1
        ? E(FormControl, {size:'small', sx:{minWidth:240}},
            E(InputLabel, null, 'Form'),
            E(Select, {value:formId, label:'Form',
              onChange:function(e){ setFormId(e.target.value); setPage(0); }},
              forms.map(function(f) { return E(MenuItem, {key:f.id, value:f.id}, f.title); })))
        : null),

    (context && !context.can_see_identity)
      ? E(Alert, {severity:'info', sx:{mb:2}},
          'Applicant names and emails are hidden from your account.')
      : null,

    E(Card, null,
      E(TableContainer, null,
        E(Table, {size:'small'},
          E(TableHead, null,
            E(TableRow, null,
              E(TableCell, null, 'Applicant'),
              context && context.can_see_identity ? E(TableCell, null, 'Email') : null,
              E(TableCell, null, 'Status'),
              E(TableCell, null, 'Submitted'),
              E(TableCell, {align:'right'}, ''))),
          E(TableBody, null,
            rows.map(function(a) {
              return E(TableRow, {key:a.id, hover:true},
                E(TableCell, null, a.applicant_name),
                context && context.can_see_identity ? E(TableCell, null, a.applicant_email) : null,
                E(TableCell, null, E(Chip, {label:a.status, size:'small', variant:'outlined'})),
                E(TableCell, null, dayjs(a.submitted_at).format('MMM D, YYYY')),
                E(TableCell, {align:'right'},
                  E(Button, {size:'small', startIcon:E(Visibility),
                    onClick:function(){ open(a.id); }}, 'View')));
            }),
            rows.length === 0
              ? E(TableRow, null, E(TableCell, {colSpan:5, align:'center',
                  sx:{py:4, color:'text.secondary'}}, 'No applications'))
              : null))),
      E(TablePagination, {component:'div', count:total, page:page, rowsPerPage:perPage,
        rowsPerPageOptions:[25, 50, 100],
        onPageChange:function(_, p){ setPage(p); },
        onRowsPerPageChange:function(e){ setPerPage(parseInt(e.target.value, 10)); setPage(0); }})),

    detail ? E(Dialog, {open:true, onClose:function(){ setDetail(null); }, maxWidth:'md', fullWidth:true},
      E(DialogTitle, null, detail.applicant_name),
      E(DialogContent, {dividers:true},
        sections.length > 0
          ? sections.map(function(sec) {
              var secFields = fields.filter(function(f) {
                return f.section_id === sec.id && detail.responses[f.id] !== undefined;
              });
              if (secFields.length === 0) return null;
              return E(Box, {key:sec.id, sx:{mb:3}},
                E(Typography, {variant:'subtitle1', fontWeight:700, color:'primary.main',
                  sx:{borderBottom:1, borderColor:'divider', pb:0.5, mb:1.5}}, sec.title),
                secFields.map(function(f) {
                  var v = detail.responses[f.id];
                  return E(Box, {key:f.id, sx:{mb:2}},
                    E(Typography, {variant:'subtitle2', color:'text.secondary', fontWeight:600}, f.label),
                    E(Typography, {variant:'body2', sx:{whiteSpace:'pre-wrap', wordBreak:'break-word'}},
                      Array.isArray(v) ? v.join(', ') : String(v)));
                }));
            })
          : fields.filter(function(f){ return detail.responses[f.id] !== undefined; }).map(function(f) {
              var v = detail.responses[f.id];
              return E(Box, {key:f.id, sx:{mb:2}},
                E(Typography, {variant:'subtitle2', color:'text.secondary', fontWeight:600}, f.label),
                E(Typography, {variant:'body2', sx:{whiteSpace:'pre-wrap', wordBreak:'break-word'}},
                  Array.isArray(v) ? v.join(', ') : String(v)));
            }),
        Object.keys(detail.responses || {}).length === 0
          ? E(Alert, {severity:'info'}, 'No questions on this form are shared with your account.')
          : null),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setDetail(null); }}, 'Close'))) : null);
}
